import { Tabs } from "antd";
import React, { useEffect, useState } from "react";
import MaterialTableComponent from "@components/MaterialTableComponent";
import LogisticService from "@LogisticService";

const AbasDeDetalhamento = (props) => {
  const { TabPane } = Tabs;
  const { nome, polo, ano, mes, tipo, resultado, distrito } = props;

  const [tabOneContent, setTabOneContent] = useState(resultado);
  const [tabTwoContent, setTabTwoContent] = useState(undefined);
  const [tabThreeContent, setTabThreeContent] = useState(undefined);
  const [tabFourContent, setTabFourContent] = useState(undefined);
  const [tabFiveContent, setTabFiveContent] = useState(undefined);
  const [tabSixContent, setTabSixContent] = useState(undefined);
  const [tabSevenContent, setTabSevenContent] = useState(undefined);

  useEffect(() => {
    setTabOneContent(props.resultado);
  }, [props]);

  function formatDate(date, hours) {
    if (date !== undefined) {
      var datePart = date.slice(0, 10);

      if (hours === undefined) {
        return (
          datePart.split("-")[2] +
          "/" +
          datePart.split("-")[1] +
          "/" +
          datePart.split("-")[0]
        );
      }

      return (
        datePart.split("-")[2] +
        "/" +
        datePart.split("-")[1] +
        "/" +
        datePart.split("-")[0] +
        " " +
        date.slice(11)
      );
    } else {
      return "--/--/--";
    }
  }

  function callback(key) {
    if (key === "1" && tabOneContent === undefined) {
      setTabOneContent([]);
    }
    if (key === "2" && tabTwoContent === undefined) {
      LogisticService.getOrdensAngels(ano, mes, nome, polo).then((response) => {
        setTabTwoContent(
          response.data.data.map((order) => ({
            order_number: order.order_number,
            contractor: order.contractor,
            customer: order.customer,
            customer_name: order.customer_name,
            city: order.city,
            technician_name: order.technician_name,
            consider_in_sla_account: order.consider_in_sla_account,
            consider_in_tma_account: order.consider_in_tma_account,
            solved_with_sla_on_time: order.solved_with_sla_on_time,
            solved_with_sla_customer_on_time:
              order.solved_with_sla_customer_on_time,
            consider_in_dzero_account: order.consider_in_dzero_account,
            solved_in_dzero: order.solved_in_dzero,
            solved_with_anticipation: order.solved_with_anticipation,
            redirect_polo: order.redirect_polo,
            service_group: order.service_group,
            status: order.status,
            cancellation_reason: order.cancellation_reason,
            opening_date: formatDate(order.opening_date, true),
            arrival_date: formatDate(order.arrival_date, true),
            deadline_date: formatDate(order.deadline_date, true),
            customer_deadline_date: formatDate(
              order.customer_deadline_date,
              true
            ),
            visitReason1: order.visitReason1,
          }))
        );
      });
    }
    if (key === "3" && tabThreeContent === undefined) {
      LogisticService.getNPSAngels(ano, mes, nome).then((response) => {
        setTabThreeContent(
          response.data.data.map((os) => ({
            angel: os.angel,
            hub: os.hub,
            district: os.district,
            rating: os.rating,
            cluster_rating: os.cluster_rating,
            answer_date: formatDate(os.answer_date),
          }))
        );
      });
    }

    if (key === "5" && tabFiveContent === undefined) {
      LogisticService.getPenalidadesDistrito(ano, mes, distrito).then(
        (response) => {
          setTabFiveContent(
            response.data.data.map((os) => {
              var date =
                os.arrival_date.split("-")[2] +
                "/" +
                os.arrival_date.split("-")[1] +
                "/" +
                os.arrival_date.split("-")[0];
              return {
                driver: os.driver,
                district: os.district_name,
                arrival_date: date,
                severity: os.severity,
              };
            })
          );
        }
      );
    }

    if (key === "6" && tabSixContent === undefined) {
      LogisticService.getAcidentesDistrito(ano, mes, distrito).then(
        (response) => {
          setTabSixContent(
            response.data.data.map((os) => {
              var date =
                os.date.split("-")[2] +
                "/" +
                os.date.split("-")[1] +
                "/" +
                os.date.split("-")[0];

              return {
                type: os.type,
                date: date,
                angel: os.angel,
                district: os.district,
              };
            })
          );
        }
      );
    }
  }

  return (
    <Tabs defaultActiveKey="1" onChange={callback}>
      <TabPane tab="Resumo" key="1">
        <div style={{ padding: "0px 100px" }}>
          <MaterialTableComponent
            columns={[
              { title: "Pilar", field: "name" },
              { title: "Atingimento", field: "score" },
              { title: "Limite Máximo", field: "limit" },
            ]}
            options={{
              showTitle: false,
              search: false,
              paging: false,
              toolbar: false,
            }}
            data={
              !tabOneContent
                ? []
                : Object.values(tabOneContent).map((p) => {
                    return {
                      name: p.nome,
                      score: p.atingimento + "%", //resultado[p],
                      limit:
                        p.indicadores
                          .filter((i) => i.tipo !== "alavanca")
                          .map((i) => parseFloat(i.peso))
                          .reduce((a, b) => a + b, 0)
                          .toFixed(1) + "%",
                      indicadores: p.indicadores,
                    };
                  })
            }
            detailPanel={(rowData) => {
              return (
                <div style={{ padding: "30px 0px" }}>
                  <MaterialTableComponent
                    columns={[
                      {
                        title: "Indicador",
                        field: "indicador",
                      },
                      {
                        title: "Resultado",
                        field: "resultado",
                      },
                      {
                        title: "Atingimento Pós-Régua",
                        field: "atingimento_regua",
                      },
                      {
                        title: "Peso",
                        field: "peso",
                      },
                      {
                        title: "Impacto no Pilar",
                        field: "contribuicao_total",
                      },
                    ]}
                    data={rowData.indicadores.map((indicador) => ({
                      indicador: indicador.nome,
                      resultado: indicador.resultado,
                      atingimento_regua: indicador.atingimento + "%",
                      peso:
                        indicador.tipo === "alavanca"
                          ? indicador.atingimento >= 0 &&
                            indicador.nome !== "acidentes_tempo_operacao"
                            ? "Bônus"
                            : "Ônus"
                          : indicador.peso + "%",
                      contribuicao_total:
                        indicador.tipo === "alavanca"
                          ? indicador.atingimento + "%"
                          : (indicador.atingimento / 100) * indicador.peso +
                            "%",
                    }))}
                    addOptions={{
                      filtering: false,
                      pageSize: 5,
                      exportButton: false,
                      search: false,
                      paging: false,
                      toolbar: false,
                    }}
                  />
                </div>
              );
            }}
          />
        </div>
      </TabPane>
      <TabPane tab="Chamados Atendidos" key="2">
        <MaterialTableComponent
          columns={[
            {
              title: "Número da OS",
              field: "order_number",
              type: "numeric",
            },
            {
              title: "Contratante",
              field: "contractor",
            },
            {
              title: "Stonecode",
              field: "customer",
            },
            {
              title: "Nome do Cliente",
              field: "customer_name",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Cidade",
              field: "city",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Angel",
              field: "technician_name",
            },
            {
              title: "Conta pro SLA",
              field: "consider_in_sla_account",
              type: "boolean",
            },
            {
              title: "Conta pro TMA",
              field: "consider_in_tma_account",
              type: "boolean",
            },
            {
              title: "SLA no Prazo",
              field: "solved_with_sla_on_time",
              type: "boolean",
            },
            {
              title: "SLA Cliente no Prazo",
              field: "solved_with_sla_customer_on_time",
              type: "boolean",
            },
            {
              title: "Conta pro D0",
              field: "consider_in_dzero_account",
              type: "boolean",
            },
            {
              title: "Resolvida em D0",
              field: "solved_in_dzero",
              type: "boolean",
            },
            {
              title: "Chamado Antecipado",
              field: "solved_with_anticipation",
              type: "boolean",
            },
            {
              title: "Grupo de Serviço",
              field: "service_group",
            },
            {
              title: "Status",
              field: "status",
            },
            {
              title: "Motivo da Primeira Visita",
              field: "visitReason1",
            },
            {
              title: "Motivo de Cancelamento",
              field: "cancellation_reason",
            },
            {
              title: "Data de Abertura",
              field: "opening_date",
            },
            {
              title: "Data de Atendimento",
              field: "arrival_date",
            },
            {
              title: "Data Limite",
              field: "deadline_date",
            },
            {
              title: "Data Limite Cliente",
              field: "customer_deadline_date",
            },
            {
              title: "Redirect",
              field: "redirect_polo",
              type: "boolean",
            },
          ]}
          data={tabTwoContent}
          title="Chamados Atendidos"
          isLoading={!tabTwoContent}
        />
      </TabPane>
      <TabPane tab="NPS" key="3">
        <MaterialTableComponent
          columns={[
            {
              title: "Angel",
              field: "angel",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Polo",
              field: "hub",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Distrito",
              field: "district",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Nota",
              field: "rating",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Classificação",
              field: "cluster_rating",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
            {
              title: "Data da resposta",
              field: "answer_date",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
          ]}
          data={tabThreeContent}
          isLoading={!tabThreeContent}
          title="NPS"
        />
      </TabPane>
      <TabPane tab="Multas" key="5">
        <MaterialTableComponent
          columns={[
            {
              title: "Motorista",
              field: "driver",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Distrito",
              field: "district",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Data de Recimento",
              field: "arrival_date",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Gravidade",
              field: "severity",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
          ]}
          data={tabFiveContent}
          isLoading={!tabFiveContent}
          title="Multas"
        />
      </TabPane>
      <TabPane tab="Acidentes" key="6">
        <MaterialTableComponent
          columns={[
            {
              title: "Tipo",
              field: "type",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Data",
              field: "date",
              cellStyle: { fontSize: "0.8em", width: "10em" },
            },
            {
              title: "Angel",
              field: "angel",
              cellStyle: { fontSize: "0.8em", width: "8em" },
            },
            {
              title: "Distrito",
              field: "district",
              cellStyle: { fontSize: "0.8em", width: "15em" },
            },
          ]}
          data={tabSixContent}
          isLoading={!tabSixContent}
          title="Acidentes"
        />
      </TabPane>
    </Tabs>
  );
};

export default AbasDeDetalhamento;
